export const state = (): PhoneNumber => ({
  phoneNumberValue: {
    base: "",
    baseRaw: "",
    formatted: "",
    extension: ""
  }
})

export const GET_PHONE_NUMBER_VALUE = "getPhoneNumberValue"

export const getters = {
  [GET_PHONE_NUMBER_VALUE]: (state: PhoneNumber): PhoneNumberPair => state.phoneNumberValue
}

export const _SET_PHONE_NUMBER_VALUE = "setPhoneNumberValue"

export const mutations = {
  [_SET_PHONE_NUMBER_VALUE](state, phoneNumberValue: PhoneNumberPair) {
    state.phoneNumberValue = phoneNumberValue
  }
}

export const SET_PHONE_NUMBER_VALUE = "setPhoneNumberValue"

export const actions = {
  [SET_PHONE_NUMBER_VALUE]({ commit }, phoneNumberValue: number) {
    commit(_SET_PHONE_NUMBER_VALUE, phoneNumberValue)
  }
}
